
export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f326dea1070f4872af0f60a6ee916a02.jpg"
          alt="Buckets Chicken Hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-red-600/80"></div>
      </div>

      <div className="relative z-10 text-center px-4 w-full max-w-5xl mx-auto">
        <div className="mb-6 animate-bounce">
          <img
            src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/a5bb4558efa960a1896a0fe4ecddc296.png"
            alt="Buckets Chicken Logo"
            className="h-20 w-20 md:h-32 md:w-32 mx-auto object-contain drop-shadow-2xl"
          />
        </div>

        <h1 className="text-4xl sm:text-6xl md:text-8xl font-black text-yellow-400 mb-4 md:mb-6 drop-shadow-lg animate-pulse leading-tight">
          BUCKETS CHICKEN
        </h1>

        <p className="text-xl sm:text-2xl md:text-4xl text-white font-bold mb-3 md:mb-4 drop-shadow-md">
          Em breve inauguração
        </p>

        <p className="text-base sm:text-xl md:text-2xl text-white mb-5 md:mb-6 drop-shadow-md px-2">
          Frango Frito Delivery - O melhor frango crocante da cidade!
        </p>

        <div className="flex items-center justify-center gap-2 mb-8 md:mb-10 px-2">
          <i className="ri-map-pin-fill text-yellow-400 text-xl md:text-2xl flex-shrink-0"></i>
          <span className="text-white text-sm md:text-lg font-semibold drop-shadow-md text-center">
            Rua José Pedro de Oliveira, 177 B - Paulínia/SP
          </span>
        </div>

        <button
          onClick={() => window.open('https://wa.me/5519971394274', '_blank')}
          className="group relative bg-yellow-400 text-black px-8 sm:px-12 py-4 sm:py-6 rounded-full text-lg sm:text-2xl font-black hover:bg-yellow-300 transition-all duration-300 hover:scale-110 shadow-2xl animate-pulse whitespace-nowrap overflow-hidden cursor-pointer"
        >
          <span className="relative z-10 flex items-center justify-center gap-2 sm:gap-3">
            <i className="ri-whatsapp-line text-2xl sm:text-3xl"></i>
            PEÇA AGORA
            <i className="ri-arrow-right-line text-2xl sm:text-3xl group-hover:translate-x-2 transition-transform"></i>
          </span>
          <div className="absolute inset-0 bg-gradient-to-r from-yellow-300 via-yellow-400 to-yellow-300 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </button>

        <div className="mt-10 md:mt-16 flex justify-center gap-4 sm:gap-8">
          <div className="text-center">
            <div className="w-14 h-14 sm:w-20 sm:h-20 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3 shadow-lg">
              <i className="ri-timer-flash-line text-2xl sm:text-4xl text-black"></i>
            </div>
            <p className="text-white font-bold text-xs sm:text-sm">Entrega Rápida</p>
          </div>
          <div className="text-center">
            <div className="w-14 h-14 sm:w-20 sm:h-20 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3 shadow-lg">
              <i className="ri-star-fill text-2xl sm:text-4xl text-black"></i>
            </div>
            <p className="text-white font-bold text-xs sm:text-sm">Qualidade Premium</p>
          </div>
          <div className="text-center">
            <div className="w-14 h-14 sm:w-20 sm:h-20 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3 shadow-lg">
              <i className="ri-fire-fill text-2xl sm:text-4xl text-black"></i>
            </div>
            <p className="text-white font-bold text-xs sm:text-sm">Sempre Crocante</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl md:text-5xl text-yellow-400"></i>
      </div>
    </section>
  );
}
